import React, { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton, Stack } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AppCardView from './AppCardView';

const AutoSlidingView = forwardRef(({
    areas = [],
    autoPlayInterval = 1500,
    itemsPerSlide = 3,
    renderItem = (item) => <AppCardView icon={<LocationOnIcon />} description={item} sx={{ flex: 1, minWidth: 0 }} />,
    ...props
}, ref) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    // Calculate total number of slides needed
    const totalSlides = Math.ceil(areas.length / itemsPerSlide);

    useEffect(() => {
        if (!isPaused && areas.length > itemsPerSlide) {
            const timer = setInterval(() => {
                setCurrentIndex((prev) => (prev + 1) % totalSlides);
            }, autoPlayInterval);

            return () => clearInterval(timer);
        }
    }, [isPaused, areas.length, totalSlides, autoPlayInterval, itemsPerSlide]);

    const handlePrevious = () => {
        setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + 1) % totalSlides);
    };

    const getVisibleAreas = () => {
        const start = currentIndex * itemsPerSlide;
        return areas.slice(start, start + itemsPerSlide);
    };

    return (
        <Box
            ref={ref}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            {...props}
        >
            <Stack direction={'row'} spacing={2} sx={{ px: 2, py: 1 }}>
                <IconButton onClick={handlePrevious}> <NavigateBeforeIcon /> </IconButton>
                {getVisibleAreas().map((item, index) => renderItem(item, index))}
                <IconButton onClick={handleNext}> <NavigateNextIcon /> </IconButton>
            </Stack>
        </Box>
    );
});

AutoSlidingView.propTypes = {
    areas: PropTypes.arrayOf(PropTypes.string).isRequired,
    autoPlayInterval: PropTypes.number,
    itemsPerSlide: PropTypes.number,
    renderItem: PropTypes.func
};

export default AutoSlidingView;
